import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";


const testimonials = [
  {
    text: "I would like to sincerely appreciate the excellent services being provided by M/s Saptveda Ventures Pvt. Ltd. Their property management process is highly transparent, and the team takes great care in explaining details and guiding customers towards the right property. I wish them continued success and all the very best for their future endeavors.",
    name: "D S Mehra",
    role: "Ex Associate Vice President",
    org:"Minda corporation limited",
    image: "/person.webp",
  },
 
  {
    text: "I had an excellent experience with Saptveda ventures pvt. Ltd. Their team is highly professional, transparent, and knowledgeable about both residential and commercial investments, will highly recommend to consult them for ur real estate investments.",
    name: "Ravi Shankar",
    role: "Admin Executive",
    org:"C-DAC",
    image: "/person.webp",
  },
   {
    text: "Hi, i have a long association with Saptveda ventures Pvt. Ltd. They not only provide excellent service related to property dealings but also take care of each minute details in terms of identification of best investment, location and ensuring that all paperwork is complete and legal, they not only provide expert support and guidance during the deal but also take care of any after sales requirement.",
    name: "Capt. Alok Singh",
    role: "Senior Commander ",
    org:"Airbus A 320",
    image: "/person.webp",
  },
];

const Testimonial = () => {
  return (
    <section className="testimonial-section">
      <div className="backdiv">

        <div className="testimonial-container">

          <div className="testimonial-left">
            <h2 className="sapt-head">TESTIMONIAL</h2>
            <p className="main-content">
             “Our clients' words reflect the trust we build, the quality we deliver, and the relationships we value. Every testimonial is a story of commitment, care, and excellence.”
            </p>
          </div>

          <div className="testimonial-right">
            <Swiper
              modules={[Autoplay]}
              slidesPerView={2}
              spaceBetween={20}
              autoplay={{ delay: 3500 }}
              loop
              breakpoints={{
                0: { slidesPerView: 1 },
                1024: { slidesPerView: 2 },
              }}
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-card">
                    <div>
                    <p className="testimonial-text">{item.text}</p>

                    <div className="testimonial-user">
                      <img src={item.image} className="testi_img" alt="test" />
                      <div>
                        <h4 className="testimonial-name">{item.name}</h4>
                        <span className="testimonial-role">{item.role}</span>
                           <p className="testimonial-role">{item.org}</p>
                      </div>
                    </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Testimonial;
